import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { TYPOGRAPHY_STYLE } from 'radiance-ui';

import { safeAreaInsetTop } from 'jsx/constants/layout';
import { ContentContainer } from 'jsx/components/layouts';

export const NavbarContainer = styled.section`
  background-color: ${({ theme }) => theme.COLORS.white};
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.border};
  width: 100%;
  z-index: 1000;
`;

export const Navbar = styled(ContentContainer)`
  align-items: center;
  display: flex;
  height: calc(
    ${SPACER.x5large} - 1px + ${safeAreaInsetTop}
  ); /* 1px for border */
  justify-content: space-between;
  padding-top: ${safeAreaInsetTop};
`;

export const NavbarSection = styled.section`
  align-items: center;
  display: flex;
  flex: 1 1 calc(100% / 3);
  justify-content: flex-start;
`;

export const MainContainer = styled.div`
  margin: 0 auto;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.COLORS.background};
  ${({ theme }) => TYPOGRAPHY_STYLE.body(theme)};
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${SPACER.x2large} ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    padding: ${SPACER.x4large} 0;
    align-items: center;

    & > * {
      width: 100%;
      max-width: 28.5rem;
    }

    & p,
    h2 {
      text-align: center;
    }
  }
`;
